export default __webpack_public_path__ + "static/media/email.b06cd76a.svg";